import { SharedModule } from 'src/app/pipes/shared-module';
import { DropDownFilterModule } from './../../dropdown-filter/dropdown-filter.component';
import { DxButtonModule, DxLoadPanelModule, DxTextBoxModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiltersGroupComponent } from './filters-group.component';
import { PageOptionsPopUpButtonModule } from '../../page-options-pop-up-button/page-options-pop-up-button.module';

@NgModule({
	declarations: [FiltersGroupComponent],
	imports: [
		CommonModule,

		// Devextreme modules.
		DxButtonModule,
		DxTextBoxModule,
		DxLoadPanelModule,

		// App modules.
		SharedModule,
		DropDownFilterModule,
		PageOptionsPopUpButtonModule,
	],
	exports: [FiltersGroupComponent]
})
export class FiltersGroupModule { }
